var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_9442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.74569 7.66797H4.25391C3.73697 7.66797 3.31641 8.08853 3.31641 8.60547V9.43016H4.87066C5.23253 9.43016 5.56284 9.56763 5.81231 9.79297C6.06178 9.56759 6.39209 9.43016 6.75397 9.43016H7.68319V8.60547C7.68319 8.08853 7.26262 7.66797 6.74569 7.66797Z",
    fill: "#626570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7457 7.66797H9.25391C8.73697 7.66797 8.31641 8.08853 8.31641 8.60547V9.43016H9.24562C9.6075 9.43016 9.93781 9.56763 10.1873 9.79297C10.4368 9.56759 10.7671 9.43016 11.1289 9.43016H12.6832V8.60547C12.6832 8.08853 12.2626 7.66797 11.7457 7.66797Z",
    fill: "#626570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4556 0.588928H3.54395C2.76854 0.588928 2.1377 1.21977 2.1377 1.99518V5.26733C2.1377 6.04274 2.76854 6.67358 3.54395 6.67358H12.4556C13.231 6.67358 13.8619 6.04274 13.8619 5.26733V1.99518C13.8619 1.21977 13.231 0.588928 12.4556 0.588928Z",
    fill: "#626570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 12.4736H15.0273H14.0898V10.8364C14.0898 10.5779 13.8795 10.3676 13.621 10.3676H11.1292C10.8708 10.3676 10.6605 10.5779 10.6605 10.8364V12.4736H9.71466V10.8364C9.71466 10.5779 9.50437 10.3676 9.24591 10.3676H6.75413C6.49566 10.3676 6.28538 10.5779 6.28538 10.8364V12.4736H5.33956V10.8364C5.33956 10.5779 5.12928 10.3676 4.87081 10.3676H2.37897C2.1205 10.3676 1.91022 10.5779 1.91022 10.8364V12.4736H0.972719H0.46875C0.209875 12.4736 0 12.6835 0 12.9423C0 13.2012 0.209875 13.4111 0.46875 13.4111H15.5312C15.7901 13.4111 16 13.2012 16 12.9423C16 12.6835 15.7901 12.4736 15.5312 12.4736Z",
    fill: "#626570"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_9442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreater);
export default __webpack_public_path__ + "static/media/threater.9f0123a0cca40107cf68177da1fba633.svg";
export { ForwardRef as ReactComponent };